import React from 'react';
import styled from 'styled-components';

const LanguageButton = ({ onClick }) => (
  <ImgContainer>
    <img alt="languages" onClick={onClick} src={require('./globe.png')} />
  </ImgContainer>
);

const ImgContainer = styled.button`
  background: transparent;
  border: none;
  margin: 0.5rem 1rem;
  position: relative;
  display: flex;
  cursor: pointer;
  img {
    height: 3rem;
    padding-right: 5px;
  }
`;

export default LanguageButton;
